<template>
  <v-data-table
    dense
    v-resize="onResize"
    :loading="loading"
    fixed-header
    disable-pagination
    disable-sort
    :height="height"
    hide-default-footer
    :headers="headers"
    :items="history"
    class="elevation-1 secondarybackground striped-table"
  >
    <template v-slot:top>
      <div class="d-flex justify-end">
        <custom-page-selector class="pa-2" namespace="requests/history" />
      </div>
    </template>
    <template v-slot:item.intervention_id="{ item }">
      {{ item.intervention_id }}
      {{ item.rejected === 'O' ? 'Rejetée' : '' }}
    </template>
    <template v-slot:item.request_datetime="{ item }">
      <v-tooltip v-if="item.customer_name" bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">{{ item.request_datetime.toLocaleDateString() }}</div>
        </template>
        <span>{{ item.customer_name }}</span>
      </v-tooltip>
      <div v-else>{{ item.request_datetime.toLocaleDateString() }}</div>
    </template>
    <template v-slot:item.on_call="{ item }">
      <v-icon color="success" v-if="item.on_call === 'O'">mdi-check</v-icon>
    </template>
    <template v-slot:item.transformed_request="{ item }">
      <v-icon color="success" v-if="item.transformed_request === 'O'">
        mdi-check
      </v-icon>
    </template>
    <template v-slot:item.description="{ item }">
      <truncate-text-with-hover :text="item.description" :length="20" />
    </template>
    <template v-slot:item.technician_comment="{ item }">
      <truncate-text-with-hover
        :text="truncateTechnicienComment(item)"
        :length="20"
      />
    </template>
    <template v-slot:item.name="{ item }">
      {{ item.technician_firstname + ' ' + item.technician_lastname }}
    </template>
  </v-data-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import resizable from '@/business/mixins/resizable';
import {
  POPUP_BOTTOM_HEIGHT,
  POPUP_TOP_HEIGHT,
} from '@/components/dialogs/customDialog.styles';
import {
  HISTORY_FILTERS_HEIGHT,
  INTERVENTIONS_TABS_HEIGHT,
  TABS_HEIGHT,
} from '@/pages/eDispatch/requestDetails/rightSide/requestsRightSide';
import HISTORY_DATATABLE_FOOTER_HEIGHT from '@/pages/eDispatch/requestDetails/rightSide/historyTab/HistoryDataTable.styles';

const { mapGetters } = createNamespacedHelpers('requests/history');
const COMMENT_START_CHAR = 48;

export default {
  name: 'HistoryDataTable',
  mixins: [resizable],
  components: {
    CustomPageSelector,
    TruncateTextWithHover,
  },
  props: {
    namespace: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      history: 'items',
      loading: 'isLoadingItems',
    }),
    height() {
      return (
        this.boilerplatePopupHeight -
        TABS_HEIGHT -
        INTERVENTIONS_TABS_HEIGHT -
        HISTORY_FILTERS_HEIGHT -
        POPUP_TOP_HEIGHT -
        POPUP_BOTTOM_HEIGHT -
        HISTORY_DATATABLE_FOOTER_HEIGHT
      );
    },
  },
  methods: {
    truncateTechnicienComment(item) {
      if (item.nature === 'DI')
        return item.technician_comment.substring(COMMENT_START_CHAR);
      return item.technician_comment;
    },
  },
  data() {
    return {
      HISTORY_DATATABLE_FOOTER_HEIGHT,
      headers: [
        { text: 'Référence', value: 'intervention_id' },
        { text: 'Libellé', value: 'description' },
        { text: 'Code', value: 'prestation_code' },
        { text: 'Date', value: 'request_datetime' },
        { text: 'Etat', value: 'status' },
        { text: 'Symptômes', value: 'work_order_group_type_name' },
        { text: 'Qualification', value: 'work_order_group_qualif_name' },
        { text: 'Motif', value: 'reason' },
        { text: 'Technicien', value: 'name' },
        { text: 'Commentaire Technicien', value: 'technician_comment' },
        { text: 'Astreinte', value: 'on_call' },
        { text: 'DIT', value: 'transformed_request' },
      ].map((item) => {
        return { ...item, align: 'center', class: 'secondarybackground' };
      }),
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
